import { createSelector } from 'reselect'

const getVersionById = (state, id) => {
    if (!id) {
        return null
    }

    const file = state.account.entities.versions[id]
    if (!file) {
        return null
    }
    return file
}

const filesSelector = state => state.account.entities.files

const getAllFileIds = state => {
  const files = state.account.entities.files
  if (!files) {
    return null
  }
  return Object.keys(state.account.entities.files)
}

const getAllFiles = createSelector(filesSelector, files => (
  files
))

const getFileById = (state, id) => {
  if(!id) {
    return null
  }
  const file = state.account.entities.files[id]
  if (!file) {
    return null;
  }
  return file
}

export { getAllFiles, getFileById, getAllFileIds, getVersionById }